import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustStrip from "../components/home/TrustStrip";
import WaterConcerns from "../components/home/WaterConcerns";
import Systems from "../components/home/Systems";
import Approach from "../components/home/Approach";
import OurWork from "../components/home/OurWork";
import AboutBlock from "../components/home/AboutBlock";
import FaqBlock from "../components/home/FaqBlock";
import FinalCta from "../components/home/FinalCta";
import Footer from "../components/Footer";

export default function LandingPage() {
  const { hash, key } = useLocation();
  useEffect(() => { document.title = "Honest Water LLC | Water Filtration & Softening in Northern Virginia"; }, []);
  useEffect(() => {
    if (hash) setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 120);
  }, [hash, key]);
  return (
    <div className="App" data-testid="landing-page">
      <Navbar transparentOnTop />
      <main>
        <Hero />
        <TrustStrip />
        <WaterConcerns />
        <Systems />
        <Approach />
        <OurWork />
        <AboutBlock />
        <FaqBlock />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
